/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Over_Budget_RaisingInputs */



/**
* | output |
* | --- |
* | "Raising…" |
*
* @param {Sub_Quotas_Over_Budget_RaisingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_raising = /** @type {((inputs?: Sub_Quotas_Over_Budget_RaisingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_RaisingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird erhöht…")
	return /** @type {LocalizedString} */ ("Raising…")
});